import DOMPurify from 'dompurify'

let hooksInstalled = false
function ensureHooks() {
  if (hooksInstalled) return
  hooksInstalled = true
  // Email links open in a new tab instead of navigating the app away.
  DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node.tagName === 'A') {
      node.setAttribute('target', '_blank')
      node.setAttribute('rel', 'noopener noreferrer')
    }
  })
  // DOMPurify strips data: URIs by default; embedded photos are safe to keep
  // on <img> only (never on links/objects, which stay blocked).
  DOMPurify.addHook('uponSanitizeAttribute', (node, data) => {
    if (node.tagName === 'IMG' && data.attrName === 'src' && /^data:image\//i.test(data.attrValue)) {
      data.forceKeepAttr = true
    }
  })
}

/**
 * Sanitize inbound email HTML for rendering inside the Inbox.
 * - Scripts/iframes/event handlers are stripped (DOMPurify defaults).
 * - <style> blocks are removed so email CSS can't bleed into the app
 *   (inline style="" attributes survive, which keeps most email layouts).
 * - `cidUrls` maps MIME Content-IDs to signed storage URLs so embedded
 *   photos (<img src="cid:...">) point at the stored attachment.
 */
export function sanitizeEmailHtml(html: string, cidUrls: Record<string, string> = {}): string {
  ensureHooks()
  let prepared = html
  for (const [contentId, url] of Object.entries(cidUrls)) {
    prepared = prepared.split(`cid:${contentId}`).join(url)
  }
  return DOMPurify.sanitize(prepared, {
    USE_PROFILES: { html: true },
    FORBID_TAGS: ['style', 'title', 'head', 'base'],
  })
}
